@if (customerConsentResponse && customerConsentResponse.consentVersion !== 'LOCK') {
  <!-- Consent: Action Buttons -->
  @if (!isMobile) {
    <div
      class="w-full sticky top-0 z-10 min-h-[72px]"
      [style.visibility]="(showSaveButtons || newConsentVersionAvailable) && customerConsentRequest && brand ? 'visible' : 'hidden'"
      [style.background-color]="(showSaveButtons || newConsentVersionAvailable) && customerConsentRequest && brand ? '#CECFD0' : 'transparent'"
    >
      <div class="max-w-[1100px] grow mx-auto">
        @if (showSaveButtons) {
          <app-action-buttons
            [showSaveButtons]="showSaveButtons"
            [dirty]="dirty"
            [willDenyCC]="willDenyCC"
            [willDenyCE]="willDenyCE"
            [noPreferredDealerError]="noPreferredDealerError"
            [noPreferredDealerLexusError]="noPreferredDealerLexusError"
            [brand]="brand"
            (save)="save()"
            (cancel)="cancel()"
          />
        } @else if (newConsentVersionAvailable) {
          <app-new-consent-version-disclaimer
            [brand]="brand"
          />
        }
      </div>
    </div>
  }
  @if (isMobile && (showSaveButtons || newConsentVersionAvailable) && customerConsentRequest && brand) {
    <div class="w-full bg-buttonsBar sticky top-0 z-10 min-h-[44px]">
      @if (showSaveButtons) {
        <app-action-buttons
          [showSaveButtons]="showSaveButtons"
          [dirty]="dirty"
          [willDenyCC]="willDenyCC"
          [willDenyCE]="willDenyCE"
          [noPreferredDealerError]="noPreferredDealerError"
          [noPreferredDealerLexusError]="noPreferredDealerLexusError"
          [brand]="brand"
          (save)="save()"
          (cancel)="cancel()"
        />
      } @else if (newConsentVersionAvailable) {
        <app-new-consent-version-disclaimer
          [brand]="brand"
        />
      }
    </div>
  }

  <app-page [size]="PageSize.HALF" [maxWidth]="'max-w-[1100px]'" [marginTop]="'mt-1 sm:mt-2'" [rightFirstOnMobile]="true">
    <ng-container left>
      <!-- Dealers -->
      @if (customerConsentRequest) {
        <div class="flex flex-col md:pr-16">
          <div [ngClass]="brand.isLexus() ? 'flex flex-col-reverse' : 'flex flex-col'">
            <!-- Toyota Preferred Dealer -->
            @if (customerConsentResponse.toyota) {
              <div>
                <app-preferred-dealer
                  [toyota]="customerConsentResponse.toyota"
                  [preferredDealer]="customerConsentRequest.preferredDealer"
                  [editPreferredDealerMode]="editPreferredDealerMode"
                  [brand]="brand"
                  (onEditPreferredDealer)="onEditPreferredDealerMode()"
                  (offEditPreferredDealer)="offEditPreferredDealerMode()"
                  class="xl:w-1/2"
                />
                <div class="mt-10 mb-5">
                  @if (editPreferredDealerMode || !this.customerConsentRequest.preferredDealer) {
                    <app-preferred-dealer-customer-update
                      [vehicleBrand]="'toyota'"
                      [customerConsentRequest]="customerConsentRequest"
                      [groupDealerList]="customerConsentRequest.groupDealerList"
                      [allDealerList]="customerConsentResponse.allDealerList"
                      [allDealerListLexus]="customerConsentResponse.allDealerListLexus"
                      (didChange)="offEditPreferredDealerMode()"
                      (dealerAdded)="onDealerAdded($event)"
                    />
                  }
                </div>
              </div>
            }

            <!-- Lexus Preferred Dealer -->
            @if (customerConsentResponse.lexus) {
              <div>
                <app-preferred-dealer
                  [lexus]="customerConsentResponse.lexus"
                  [preferredDealerLexus]="customerConsentRequest.preferredDealerLexus"
                  [editPreferredDealerLexusMode]="editPreferredDealerLexusMode"
                  [brand]="brand"
                  (onEditPreferredDealerLexus)="onEditPreferredDealerLexusMode()"
                  (offEditPreferredDealerLexus)="offEditPreferredDealerLexusMode()"
                  class="xl:w-1/2"
                />
                <div class="mt-10 mb-2">
                  @if (editPreferredDealerLexusMode || !this.customerConsentRequest.preferredDealerLexus) {
                    <app-preferred-dealer-customer-update
                      [vehicleBrand]="'lexus'"
                      [customerConsentRequest]="customerConsentRequest"
                      [groupDealerList]="customerConsentRequest.groupDealerList"
                      [allDealerList]="customerConsentResponse.allDealerList"
                      [allDealerListLexus]="customerConsentResponse.allDealerListLexus"
                      (didChange)="offEditPreferredDealerLexusMode()"
                      (dealerAdded)="onDealerAdded($event)"
                    />
                  }
                </div>
              </div>
            }
          </div>

          <div class="mt-10">
            <app-group-dealer
              [customerConsentRequest]="customerConsentRequest"
              [customerConsentResponse]="customerConsentResponse"
              [editMode]="showSaveButtons"
              [brand]="brand"
              (didChange)="validate()"
              class="mt-10"
            />
          </div>
        </div>
      }
    </ng-container>

    <ng-container right>
      <!-- Communication, profiling, data sharing -->
      <div class="flex flex-col gap-2">
        <app-communication
          [brand]="brand"
          [customerConsentRequest]="customerConsentRequest"
          [customerConsentResponse]="customerConsentResponse"
          [descriptionText]="getCommunicationDescriptionText()"
          (contactEventChanged)="validate()"
          (contactChannelChanged)="validate()"
        />

        @if (getContactEvent('PROFILING')) {
          <app-profiling
            [brand]="brand"
            [customerConsentRequest]="customerConsentRequest"
            [descriptionText]="getContactEvent('PROFILING').customerDescription"
            (didChange)="validate()"
          />
        }

        @if (getContactEvent('DATA_SHARING')) {
          <app-data-sharing
            [brand]="brand"
            [customerConsentRequest]="customerConsentRequest"
            [descriptionText]="getContactEvent('DATA_SHARING').customerDescription"
            (didChange)="validate()"
          />
        }
      </div>
    </ng-container>
  </app-page>
} @else if (customerConsentResponse?.consentVersion === 'LOCK') {
  <!-- BLACK LIST -->
  <app-page [size]="PageSize.SINGLE">
    <app-blacklist [brand]="brand" [legalEntity]="legalEntity" />
  </app-page>
} @else {
  <app-loading-spinner />
}

